import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Bands from './pages/Bands';
import Musicians from './pages/Musicians';
import MusicianDetails from './pages/MusicianDetails';
import Agenda from './pages/Agenda';
import Stories from './pages/Stories';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import CreateProfile from './pages/CreateProfile';
import BecomeMusician from './pages/BecomeMusician';
import CreateBand from './pages/CreateBand';
import EditBand from './pages/EditBand';
import BandDetails from './pages/BandDetails';
import CreateStory from './pages/CreateStory';
import EditStory from './pages/EditStory';
import CreateEvent from './pages/CreateEvent';
import EditEvent from './pages/EditEvent';
import EventDetails from './pages/EventDetails';
import BookBand from './pages/BookBand';
import Settings from './pages/Settings';
import Contact from './pages/Contact';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import TermsAndConditions from './pages/TermsAndConditions';
import FAQ from './pages/FAQ';
import FanContent from './pages/FanContent';
import ManageFanContent from './pages/ManageFanContent';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import MusikerFindenSchweiz from './pages/seo/MusikerFindenSchweiz';
import MusikerFindenBern from './pages/seo/MusikerFindenBern';
import MusikerFindenZuerich from './pages/seo/MusikerFindenZuerich';
import BandFindenSchweiz from './pages/seo/BandFindenSchweiz';
import BandFindenBern from './pages/seo/BandFindenBern';
import BandFindenZuerich from './pages/seo/BandFindenZuerich';
import LivemusikBuchenSchweiz from './pages/seo/LivemusikBuchenSchweiz';
import { AuthProvider } from './contexts/AuthContext';
import { GoogleMapsProvider } from './contexts/GoogleMapsContext';
import { RecaptchaProvider } from './contexts/RecaptchaContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <RecaptchaProvider>
          <GoogleMapsProvider>
            <div className="min-h-screen bg-dark flex flex-col">
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/bands" element={<Bands />} />
                  <Route path="/bands/new" element={<CreateBand />} />
                  <Route path="/bands/:slug" element={<BandDetails />} />
                  <Route path="/bands/:slug/edit" element={<EditBand />} />
                  <Route path="/bands/:bandSlug/stories/new" element={<CreateStory />} />
                  <Route path="/bands/:bandSlug/stories/:storySlug/edit" element={<EditStory />} />
                  <Route path="/bands/:bandSlug/events/new" element={<CreateEvent />} />
                  <Route path="/bands/:bandSlug/events/:eventSlug" element={<EventDetails />} />
                  <Route path="/bands/:bandSlug/events/:eventSlug/edit" element={<EditEvent />} />
                  <Route path="/bands/:bandSlug/fan-content" element={<FanContent />} />
                  <Route path="/bands/:bandSlug/manage-fan-content" element={<ManageFanContent />} />
                  <Route path="/book-band" element={<BookBand />} />
                  <Route path="/book-band/:slug" element={<BookBand />} />
                  <Route path="/musicians" element={<Musicians />} />
                  <Route path="/musicians/:slug" element={<MusicianDetails />} />
                  <Route path="/agenda" element={<Agenda />} />
                  <Route path="/stories" element={<Stories />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/profile/edit" element={<EditProfile />} />
                  <Route path="/create-profile" element={<CreateProfile />} />
                  <Route path="/become-musician" element={<BecomeMusician />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/imprint" element={<Imprint />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:id" element={<BlogPost />} />
                  {/* SEO Landing Pages */}
                  <Route path="/musiker-finden-schweiz" element={<MusikerFindenSchweiz />} />
                  <Route path="/musiker-finden-bern" element={<MusikerFindenBern />} />
                  <Route path="/musiker-finden-zuerich" element={<MusikerFindenZuerich />} />
                  <Route path="/band-finden-schweiz" element={<BandFindenSchweiz />} />
                  <Route path="/band-finden-bern" element={<BandFindenBern />} />
                  <Route path="/band-finden-zuerich" element={<BandFindenZuerich />} />
                  <Route path="/livemusik-buchen-schweiz" element={<LivemusikBuchenSchweiz />} />
                  {/* Catch all route for 404s */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </GoogleMapsProvider>
        </RecaptchaProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;